//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"Depth",0,"Expression",0],[0,"DepthSide",1,0],[1,"DieRadius",0,"Expression",0],[0,"EndType",1,0],[0,"IncludeRounding",1,0],[1,"MinimumToolClearance",0,"Expression",0],[0,"Section",1,"Section",0],[0,"SectionSide",1,0],[0,"Sketch",1,"Features.SketchFeature",0],[1,"Width",0,"Expression",0]],[[[],"ValidateBuilderData",{R_:{valid:''}},0,0]],[]];
SPLM.Features.SheetMetal.LouverBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.LouverBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.LouverBuilder.DepthSideOptions = Object.freeze({
    "SectionNormalSide" : "SectionNormalSide", "SectionReverseNormalSide" : "SectionReverseNormalSide"});

SPLM.Features.SheetMetal.LouverBuilder.SectionSideOptions = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.Features.SheetMetal.LouverBuilder.EndTypeOptions = Object.freeze({
    "Formed" : "Formed", "Lanced" : "Lanced"});

export default SPLM;